const PERSIAN_ZERO = 0x06f0;
const ARABIC_ZERO = 0x0660;
/** Arabic decimal separator (٫) — a decimal point, not a thousand separator. */
const ARABIC_DECIMAL = /٫/g;
/** Arabic thousands separator (٬), comma, and any whitespace or bidi mark. */
const GROUPING = /[٬,\s‎‏]/g;
/** Longer than any price or quantity the exchange accepts — keeps a stray paste sane. */
const MAX_DIGITS = 15;

/**
 * The first number found in pasted text, as digits the keypad can hold.
 *
 * Accepts Persian (۱۲۳) and Arabic (١٢٣) digits and grouped text such as
 * `«۱۲,۳۵۰ ریال»`. A decimal part is dropped because the keypad is integer-only.
 * Returns an empty string when the text carries no number.
 */
export function parseClipboardNumber(raw: string): string {
	const normalized = raw
		.replace(/[۰-۹]/g, char => String(char.charCodeAt(0) - PERSIAN_ZERO))
		.replace(/[٠-٩]/g, char => String(char.charCodeAt(0) - ARABIC_ZERO))
		.replace(ARABIC_DECIMAL, '.')
		.replace(GROUPING, '');

	const match = normalized.match(/\d+(?:\.\d+)?/);
	if (!match) {
		return '';
	}

	// Trim the leading zeros by hand: Number() would lose precision on long digit runs.
	const whole = match[0].split('.')[0].replace(/^0+(?=\d)/, '');
	return whole.slice(0, MAX_DIGITS);
}
